import React, { Component } from 'react'
import { FlatList, View, StyleSheet } from 'react-native'

export default class ListWrapper extends Component {
  static defaultProps = {
    numberOfColumns: 1,
  }

  listRef = list => {
    this._list = list
  }

  renderItem = ({ item }) => {
    const { renderItem } = this.props

    const renderedItem = !item || item.empty ? null : renderItem({ item })

    return (
      <View key={item.id} style={[styles.listItem]}>
        {renderedItem}
      </View>
    )
  }

  getColumns() {
    const { data, numberOfColumns } = this.props
    const columns = []

    for (let i = 0; i < data.length; i += numberOfColumns) {
      for (let j = 0; j < numberOfColumns; j += 1) {
        const pos = i + j

        if (!columns[j]) {
          columns[j] = []
        }

        if (data[pos]) {
          columns[j].push(data[pos])
        }
      }
    }

    return columns
  }

  getData() {
    let { data, numberOfColumns } = this.props

    if (data.length % numberOfColumns !== 0) {
      const padCount = numberOfColumns - (data.length % numberOfColumns)
      data = data.slice()

      for (let i = 0; i < padCount; i += 1) {
        data.push({ empty: true, key: `pad-${i}` })
      }
    }
    return data
  }

  keyExtractor = itm => {
    return String(itm.id)
  }

  render() {
    const { numberOfColumns, listKey, object } = this.props
    const columns = this.getColumns()

    if (numberOfColumns === 1 || !object.attributes.masonry) {
      return (
        <FlatList
          ref={this.listRef}
          data={this.getData()}
          keyExtractor={this.keyExtractor}
          listKey={listKey}
          renderItem={this.renderItem}
          showsVerticalScrollIndicator={false}
          numColumns={numberOfColumns}
        />
      )
    } else {
      return (
        <View style={styles.wrapper}>
          {columns.map((column, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <View key={i} style={styles.column}>
              {column.map(item => this.renderItem({ item }))}
            </View>
          ))}
        </View>
      )
    }
  }
}

const styles = StyleSheet.create({
  wrapper: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  column: {
    flexDirection: 'column',
    flex: 1,
  },
  listItem: {
    flex: 1,
  },
})
